import React from "react";
var __jsx = React.createElement;
import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import FiftyFifty from './FiftyFifty';
function FiftyFiftyAdapter(_ref) {
  var entry = _ref.entry;
  var fiftyFiftyData = useContentfulLiveUpdates(entry);
  return __jsx(FiftyFifty, {
    fiftyFiftyData: fiftyFiftyData
  });
}
export default FiftyFiftyAdapter;